import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

const size = {
  default: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="oneRepMaxIconKnockout" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" rx="6" fill="white" />
        <path d="M5.30762 8.16357V16H3.76074V9.94678L1.90234 10.5376V9.31836L5.14111 8.16357H5.30762Z" fill="black" />
        <path
          d="M6.69465 8.17969H9.61115C10.2091 8.17969 10.723 8.26921 11.1527 8.44824C11.5859 8.62728 11.9189 8.89225 12.1517 9.24316C12.3844 9.59408 12.5008 10.0256 12.5008 10.5376C12.5008 10.9565 12.4292 11.3164 12.286 11.6172C12.1463 11.9144 11.9476 12.1632 11.6898 12.3638C11.4355 12.5607 11.1365 12.7183 10.7928 12.8364L10.2825 13.105H7.74738L7.73664 11.8481H9.62189C9.90477 11.8481 10.1393 11.798 10.3255 11.6978C10.5117 11.5975 10.6514 11.4578 10.7445 11.2788C10.8411 11.0998 10.8895 10.8921 10.8895 10.6558C10.8895 10.4051 10.8429 10.1885 10.7498 10.0059C10.6567 9.82324 10.5153 9.68359 10.3255 9.58691C10.1357 9.49023 9.89761 9.44189 9.61115 9.44189H8.30598V16H6.69465V8.17969ZM11.0667 16L9.28352 12.5142L10.9862 12.5034L12.7908 15.9248V16H11.0667Z"
          fill="black"
        />
        <path
          d="M14.2574 8.17969H15.6216L17.6304 13.9214L19.6392 8.17969H21.0035L18.1783 16H17.0826L14.2574 8.17969ZM13.5215 8.17969H14.8804L15.1275 13.7764V16H13.5215V8.17969ZM20.3804 8.17969H21.7447V16H20.1333V13.7764L20.3804 8.17969Z"
          fill="black"
        />
      </mask>
      <rect width="24" height="24" rx="6" fill="currentColor" mask="url(#oneRepMaxIconKnockout)" />
    </svg>
  ),
};

function OneRepMaxIcon(props: SvgIconProps) {
  const item = size[props.fontSize as keyof typeof size] ?? size.default;
  return <SvgIcon {...props}>{item}</SvgIcon>;
}
export default OneRepMaxIcon;
